<template>
    <div class="card st-framework-card">

        <div class="card-header">
            <table style="width: 100%;">
                <tr>
                    <td style="margin: 0; padding: 0 0 0 7px; width: 40px;" v-if="environment === 'Local'">
                        <button type="button" class="btn btn-dark btn-sm" v-on:click="reloadPluginFiles(['faces/faces.rb'])">
                            <font-awesome-icon :icon="['fas','sync']"/>
                        </button>
                    </td>
                    <td style="margin: 0; padding: 0 0 0 7px; width: 40px;" v-else>
                        <button type="button" class="btn btn-dark btn-sm" v-on:click="reloadPage()">
                            <font-awesome-icon :icon="['fas','sync']"/>
                        </button>
                    </td>
                    <td style="margin: 0; padding: 0; width: 230px;">
                        {{ $i18n.tc('translations.' + name, 2).toUpperCase() }}
                    </td>
                    <template v-if="serverDataLoaded">
                        <td style="width: 1rem;"></td>
                        <template v-if="data.model.project">
                            <td style="padding: 0 10px; border: solid 1px lightgray; width: 30%;" v-if="data.model.phase">
                                {{ data.model.phase.label }}
                            </td>
                            <td style="width: 30%;" v-else/>
                            <td style="width: 1rem;"/>
                            <td style="padding: 0 10px; border: solid 1px lightgray;">
                                <LinkAction :action="actions.modelLinkAction"/>
                            </td>
                            <td style="padding: 0; width: 90px; text-align: right;">
                                (#{{ data.model.phase ? data.model.phase.id : (data.model.order ? data.model.order.id : data.model.project.id) }})
                            </td>
                        </template>
                        <template v-else>
                            <td style="padding: 0 10px; border: solid 1px lightgray;">
                                <router-link :to="{name: 'order_list'}" class="st-cardheader-link">
                                    {{ $i18n.t('translations.SketchUp model is not linked to a project') }}!
                                </router-link>
                            </td>
                        </template>
                        <td style="width: 1rem;"></td>
                    </template>
                    <td v-else/>
                </tr>
            </table>
        </div>

        <template v-if="incompatibleSketchUpPlugin">
            <div class="card-body" style="text-align: center; font-size: larger; font-weight: bold; color: red;">
                <div>{{ $i18n.t("translations.incompatibleSketchUpPluginVersionForModule", {version: this.minimumSketchUpPluginVersion}) }}</div>
            </div>
        </template>
        <template v-else-if="serverDataLoaded">
            <div class="card-body p-0">
                <Table :key="'areas-table-'+reloadTableComponent" header-class="light" footer-class="light" body-class=""
                       with-filter with-pagination pagination-always-visible no-state-loading autofocus
                       :lines-per-page=data.crudLinesPerPage
                       :reload-table-data="reloadTableData"
                       :rows="processedComponentList"
                       :fields="fields.table" :actions="actions.table" :state="state"
                       :total-fields="fields.tableTotals" :totals="processedComponentTotals"
                       v-on:clear-selection="clearSelection"
                       v-on:inline-edit="inlineEdit"
                       v-on:refresh="getFaces"
                       v-on:select-all="selectAll"
                       v-on:select-component="selectComponent"/>
            </div>
        </template>

    </div>
</template>

<script>
import LinkAction from "@/components/actions/LinkAction.vue";
import SketchUp from "@/mixins/SketchUp";
import Table from "@/components/Table";

/* global sketchup:false */

export default {
    name: 'Areas',
    components: {
        LinkAction,
        Table,
    },
    props: ['name', 'icon', 'api', 'state', 'environment'],
    mixins: [SketchUp],
    data() {
        return {
            serverDataLoaded: false,
            reloadTableComponent: 0,
            reloadTableData: 0,
            sketchUpToolData: null,
            minimumSketchUpPluginVersion: '1.26.0',
            incompatibleSketchUpPlugin: false,
            data: null,
            fields: null,
            actions: null,
            processedComponentList: [],
            processedComponentTotals: {},
        }
    },
    created() {
        window.vm.Tool = this;
        this.getToolData();
    },
    methods: {
        clearSelection() {
            sketchup.clearSelection();
        },
        fetchData() {
            this.$http.get(this.api + '/manage_areas/' + this.sketchUpToolData.project_id + '/' + this.sketchUpToolData.order_id + '/' + this.sketchUpToolData.phase_id, {}).then((res) => {
                this.actions = res.data.actions;
                this.fields = res.data.fields;
                this.data = res.data.data;
                this.serverDataLoaded = true;
                this.getFaces();
            }).catch((error) => {
                console.log("Areas:fetchData():error:", error);
            });
        },
        getFaces() {
            this.state.loading = true;
            sketchup.getFaces();
        },
        getFacesCallback(entities) {
            this.$worker.run((rawComponentList) => {
                let processedComponentList = [];
                const materialType = ['SOLID', 'TEXTURED', 'COLORIZED_TEXTURED'];

                rawComponentList.forEach(component => {
                    let i = processedComponentList.findIndex(item =>
                        (item.material_name === component.material_name)
                    );
                    if (i === -1) {
                        processedComponentList.push({
                            'entity_ids': [component.entity_id],
                            'material_type': (typeof materialType[component.material_type] === 'undefined' ? 'N/A' : materialType[component.material_type]),
                            'material_name': component.material_name,
                            'material_color': {
                                value: component.material_color,
                                label: component.material_name,
                            },
                            'quantity': 1,
                            'area': Math.round(10 * component.area) / 10,
                            'area_square_m': Math.round(100 * component.area / 1000000) / 100,
                        });
                    } else {
                        if (processedComponentList[i].entity_ids.indexOf(component.entity_id) === -1) {
                            processedComponentList[i].entity_ids.push(component.entity_id);
                        }
                        processedComponentList[i].quantity++;
                        processedComponentList[i].area = Math.round(10 * (processedComponentList[i].area + component.area)) / 10;
                        processedComponentList[i].area_square_m = Math.round(100 * processedComponentList[i].area / 1000000) / 100;
                    }
                });
                processedComponentList.forEach(component => {
                    component.area_f = component.area.toFixed(1).replace('.', ',');
                    component.area_square_m_f = (Math.round(100 * component.area / 1000000) / 100).toFixed(2).replace('.', ',');
                });

                processedComponentList.sort(function (a, b) {
                    if (a.material_name.toLowerCase() < b.material_name.toLowerCase()) return -1;
                    if (a.material_name.toLowerCase() > b.material_name.toLowerCase()) return 1;
                    return 0;
                });

                return processedComponentList;
            }, [JSON.parse(entities)]).then(data => {
                this.processedComponentList = data;
                this.processedComponentTotals = {};
                this.reloadTableComponent++;
                this.state.loading = false;
            }).catch(error => {
                console.log("Areas:getFacesCallback():error:", error);
            });
        },
        getToolData() {
            this.state.loading = true;
            sketchup.getToolData();
        },
        getToolDataCallback(data) {
            this.sketchUpToolData = data;
            if (this.isVersionGreaterOrEqual(this.sketchUpToolData.plugin_version, this.minimumSketchUpPluginVersion)) {
                this.fetchData();
            } else {
                this.incompatibleSketchUpPlugin = true;
                this.state.loading = false;
            }
        },
        inlineEdit(data) {
            let i = this.processedComponentList.findIndex(item => item.material_name === data.material_name);
            this.processedComponentList[i].weight = (Math.round(100 * 7850 * this.processedComponentList[i].area * this.processedComponentList[i].thickness / (1000 * 1000000)) / 100).toFixed(2);
            this.processedComponentList[i].weight_f = this.processedComponentList[i].weight.replace('.', ',');
            this.processedComponentTotals = {
                weight: 0,
                weight_f: ''
            };
            this.processedComponentList.forEach(component => {
                this.processedComponentTotals.weight += component.weight ? parseFloat(component.weight) : 0;
            });
            this.processedComponentTotals.weight_f = this.processedComponentTotals.weight.toFixed(2).replace('.', ',');
            this.reloadTableData++;
        },
        selectAll() {
            sketchup.selectAll();
        },
        selectComponent(data) {
            sketchup.selectComponents(data.entity_ids);
        },
    }
}
</script>

<style scoped>
</style>
